import {
    NotificationLevel,
    NotificationThresholdFormState,
    NotificationThresholds,
} from 'modules/settings/components/custom-notifications/custom-notification-threshold.model';

interface ThresholdOwner {
    notifications: NotificationThresholds;
}

interface ResetOwner {
    isResettable: boolean;
    requiresCommentOnReset: boolean;
}

export const withThresholdField = <TState extends ThresholdOwner, TField extends keyof NotificationThresholdFormState>(
    state: TState,
    level: NotificationLevel,
    field: TField,
    value: NotificationThresholdFormState[TField]
): TState => ({
    ...state,
    notifications: {
        ...state.notifications,
        [level]: { ...state.notifications[level], [field]: value },
    },
});

export const withResettable = <TState extends ResetOwner>(state: TState, isResettable: boolean): TState => ({
    ...state,
    isResettable,
    requiresCommentOnReset: isResettable && state.requiresCommentOnReset,
});
